<template
  ><div style="padding-top:-2px;margin-top:-2px;">
      <v-label ><b>{{label}}</b></v-label>
    <s-select-generic
        class="text"
      itemtext="GenDescription"
      itemvalue="GenID" :disabled=disabled
      id="GenDescription"
      :value="value" :return-object=returnObject
      @input="input($event)" 
      :config="config" 
      :text="text" :clearable=clearable :no-default=noDefault
    >
    </s-select-generic>
  </div>
</template>

<script>
import _sGenericService from "./../../services/General/GenericService";
export default {
  name: "SelectArea",
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
     clearable: {
      type: Boolean,
      default: false,
    },
    value: null,
    text: { type: String, default: "" },
    label: {
      type: String,
      default: "",
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
    noDefault: {
      type: Boolean,
      default: false,
    },
    SitID: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    SitID(){
      this.config.params.SitID=this.SitID;
    },
    value(value) {
      this.item = value;
    },
  },
  methods: {
    input(val) {
      this.$emit("input", val);
    },
  
    },
    data: () => ({
        item: 0,
        val:'',
        items: [],
        config: {},
    }),
  
    created() {
        this.config = {
            url:_sGenericService.getUrlCompanySystem(),
            title: this.label,
            params: {SitID:this.SitID,search:'',requestID:this.$fun.getUserID() }
        }

    }

  }

</script>
